import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { toRoutePattern, track } from "@/lib/analytics";

/**
 * Emits `page.viewed` on every navigation.
 *
 * Renders nothing and must sit INSIDE the router, since useLocation needs the
 * router context. It records the route PATTERN rather than the pathname — see
 * route-patterns.ts for why that distinction is a privacy boundary and not a
 * formatting preference.
 */
export function RouteAnalytics(): null {
  const location = useLocation();

  useEffect(() => {
    // toRoutePattern runs before track's internal guard, and this is inside a
    // React effect — an uncaught throw here would take down the whole route
    // tree via the error boundary. A missed page view is the cheaper failure.
    try {
      track("page.viewed", {}, { path: toRoutePattern(location.pathname) });
    } catch {
      // Analytics must not be able to blank the app.
    }
  }, [location.pathname]);

  return null;
}
